import feedbackForm from "@/pages/feedback/feedbackForm.vue";
import systemFeedbackForm from "@/pages/system_feedback/feedbackForm.vue";
import feedbackList from "@/pages/tickets/feedbackList.vue";
import systemFeedbackList from "@/pages/system_feedback/feedbackList.vue";
import systemTicket from "@/pages/system_feedback/systemTicket.vue";

const routes = [
  { // /feedbacks
    path: '/feedbacks',
    name: 'feedbacks',
    component: feedbackList,
    meta:{
      name: 'Feedbacks',
      requireAuth: true
    },
  },
  { // /feedback/configuration
    path: '/feedback/configuration',
    name: 'feedback-config',
    component: feedbackForm,
    meta:{
      name: 'Feedback Setting',
      requireAuth: true
    },
  },
  { // /system-feedbacks/:id
    path: '/system-feedbacks/:id',
    name: 'system-ticket',
    component: systemTicket,
    meta:{
      name: 'System Feedback',
      requireAuth: true
    },
  },
  { // /system-feedbacks
    path: '/system-feedbacks',
    name: 'system-feedbacks',
    component: systemFeedbackList,
    meta:{
      name: 'System Feedbacks',
      requireAuth: true
    },
  },
  { // /system-feedback/configuration
    path: '/system-feedback/configuration',
    name: 'system-feedback-config',
    component: systemFeedbackForm,
    meta:{
      name: 'System Feedback Setting',
      requireAuth: true
    },
  },
]

export default routes